/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Copy_Text_LabelInputs */

const en_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy text from selected events`)
};

const fr_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le texte des événements sélectionnés`)
};

const de_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text aus ausgewählten Ereignissen kopieren`)
};

const it_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia il testo dagli eventi selezionati`)
};

const ru_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать текст из выбранных событий`)
};

const es_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto de eventos seleccionados`)
};

const zh_cn2_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从选定的事件中复制文本`)
};

const ja_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントからテキストをコピー`)
};

const hi_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं से पाठ कॉपी करें`)
};

const pt_pt2_context_menu_copy_text_label = /** @type {(inputs: Context_Menu_Copy_Text_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto dos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Copy text from selected events" |
*
* @param {Context_Menu_Copy_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy_text_label = /** @type {((inputs?: Context_Menu_Copy_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Copy_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_copy_text_label(inputs)
	if (locale === "de") return de_context_menu_copy_text_label(inputs)
	if (locale === "it") return it_context_menu_copy_text_label(inputs)
	if (locale === "ru") return ru_context_menu_copy_text_label(inputs)
	if (locale === "es") return es_context_menu_copy_text_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_copy_text_label(inputs)
	if (locale === "ja") return ja_context_menu_copy_text_label(inputs)
	if (locale === "hi") return hi_context_menu_copy_text_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_copy_text_label(inputs)
	return en_context_menu_copy_text_label(inputs)
});